import {getItemLocalStorage} from "../../../Utils/utils";

export const GET_ENTITY_BY_PERMALINK = "GET_ENTITY_BY_PERMALINK";


export function getEntityByID(id, proyeccion, time_init) {
    const time_end = new Date().getTime()
    // console.log("actionsEntities::getEntityByID()::timing --> [" + (time_end - time_init) + " ms]");
    // console.log("actionsEntities::getEntityByID("+id+", "+proyeccion+")");
    return (dispatch, getState) => {
        const time_end = new Date().getTime()
        let viewerLatLngStr, viewerLatlng
        try {
            viewerLatLngStr = localStorage?.getItem('viewerLatLng');
            viewerLatlng = JSON.parse(viewerLatLngStr)
        } catch (e) {
            console.error("LocalStorage is nor accesible");
        }
        // console.log("actionsEntities::getEntityByID()::ajax::timing --> [" + (time_end - time_init) + " ms]");
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            //data: JSON.stringify(datos),
            data: {
                proyeccion: proyeccion
            },
            //
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            beforeSend: function (req) {
                if(viewerLatlng?.lat) req.setRequestHeader('adopta-viewer-latitude', viewerLatlng?.lat);
                if(viewerLatlng?.lng) req.setRequestHeader('adopta-viewer-longitude', viewerLatlng?.lng);
            },
            // URL a la que se enviará la solicitud Ajax
            url: "/api/entity/" + id,
        })
            .done(function (response, textStatus, jqXHR) {
                // console.log("actionsEntities::getEntityByID()::done()");
                // console.log("entity.nombre = '" + response.nombre + "'");
                dispatch({type: GET_ENTITY_BY_PERMALINK, payload: {infoEntity: response}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                // console.log("actionsEntities::getEntityByID()::fail()");

                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log){
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    };
}


export function getEntityByPermalink(permalink, proyeccion, time_init) {
    // console.log("actionsEntities::getEntityByPermalink()::timing --> [" + (new Date().getTime() - time_init) + " ms]");
    // console.log("actionsEntities::getEntityByID("+id+", "+proyeccion+")");
    return (dispatch, getState) => {

        let dataLS = getItemLocalStorage('initDataBE-entity')
        let viewerLatlng = getItemLocalStorage('viewerLatLng')

        if (dataLS && permalink === dataLS.entity.permalink){
                return dispatch({type: GET_ENTITY_BY_PERMALINK, payload: {infoEntity: dataLS.entity}});
        } else {
            // console.log("actionsEntities::getEntityByID()::ajax::timing --> [" + (new Date().getTime() - time_init) + " ms]");
            $.ajax({
                //Cambiar a type: POST si necesario
                type: "GET",
                //Datos que se envian
                //data: JSON.stringify(datos),
                data: {
                    proyeccion: proyeccion
                },
                beforeSend: function (req) {
                    if(viewerLatlng?.lat) req.setRequestHeader('adopta-viewer-latitude', viewerLatlng?.lat);
                    if(viewerLatlng?.lng) req.setRequestHeader('adopta-viewer-longitude', viewerLatlng?.lng);
                },
                //
                // Formato de datos que se espera en la respuesta
                dataType: "json",
                // URL a la que se enviará la solicitud Ajax
                url: "/api/entity/permalink/" + permalink,
            })
                .done(function (response, textStatus, jqXHR) {
                    // console.log("actionsEntities::getEntityByPermalink()::done()::timing --> [" + (new Date().getTime() - time_init) + " ms]");
                    // console.log("entity.nombre = '" + response.nombre + "'");
                    dispatch({type: GET_ENTITY_BY_PERMALINK, payload: {infoEntity: response}});
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    //console.log("actionsEntities::getEntityByPermalink()::fail()");

                    let errorStr;
                    if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                        errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                    } else {
                        errorStr = jqXHR.responseJSON;
                    }

                    if (console && console.log){
                        console.log("La solicitud a fallado: " + errorStr);
                    }
                });
        }
    };
}


export function resetinfoEntity() {
    // console.log("******************************");
    // console.log(" ***  RESET ENTITY DETAIL  ***");
    // console.log("******************************");
    return (dispatch, getState) => {
        dispatch({type: GET_ENTITY_BY_PERMALINK, payload: {infoEntity: {}}});
    }
}

// **************************CARTAS DETALLES ANIMAL*******************************


